import { render, staticRenderFns } from "./helpDoc.vue?vue&type=template&id=28e1b1c2&scoped=true&"
import script from "./helpDoc.vue?vue&type=script&lang=js&"
export * from "./helpDoc.vue?vue&type=script&lang=js&"
import style0 from "./helpDoc.vue?vue&type=style&index=0&id=28e1b1c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e1b1c2",
  null
  
)

component.options.__file = "helpDoc.vue"
export default component.exports